var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PermissionGroup",class:{ "clickable": !!_vm.onClick },on:{"click":_vm.onClick}},_vm._l((_vm.sortedPermissions),function(permission){return _c('ja-permission-item',_vm._b({key:permission.id},'ja-permission-item',permission,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }